export const questions = [
  {
    name: '92381357-5c83-4c49-abb8-86802e1dffa8',
    text: 'How often do you feel that you have no one to talk to?',
    options: [
      {
        name: '22e1fdf7-3c52-45a7-a5ed-3526eb3a36a6',
        text: 'Hardly Ever',
      },
      {
        name: 'ed55a88f-ded6-4024-8c54-f402ff39ed93',
        text: 'Sometimes',
      },
      {
        name: 'c7d1b100-1414-4237-a366-2830ba166f48',
        text: 'Often',
      },
    ],
  },
  {
    name: '12fbcb14-bdc2-4a8f-abb3-d6e97b532cd8',
    text: 'How often do you feel left out?',
    options: [
      {
        name: 'b5844d0c-6aab-4a72-9f32-8d2204f720bb',
        text: 'Hardly Ever',
      },
      {
        name: '1d1240f7-a5df-4d28-b4d7-d36fcb314024',
        text: 'Sometimes',
      },
      {
        name: '37ac84e4-d790-4609-9945-8301b27cbb88',
        text: 'Often',
      },
    ],
  },
  {
    name: '65ec7994-399c-4519-853e-5c3eb5266bf0',
    text: 'How often do you feel alone?',
    options: [
      {
        name: '772efa89-d811-46b9-a429-a508915dc4b3',
        text: 'Hardly Ever',
      },
      {
        name: 'eb66988b-dd04-4903-95df-2d8cfb25eea4',
        text: 'Sometimes',
      },
      {
        name: '40699625-ac2f-4a3e-92bd-c56aba5cce50',
        text: 'Often',
      },
    ],
  },
];
